export enum PageChildrenEnum {
    Expose,
    Story,
    PickUp,
    Map,
    Back,
    None,
}

export enum HighlightEnum {
    Equipment,
    Technology,
    Charging,
    Services,
}

export enum CarDetailEnum {
    Overview = 1,
    Highlight,
    Optional,
    Standard,
}

export enum OverlayEnum {
    HomeScreen,
    ShareExpose,
    InfoChecklist,
    AdditionalInfo,
    InfoRental,
    Hotline,
    ValueCredit,
    Loading,
    WrongVIN,
    ExternalContent,
}

export enum ASSubpageEnum {
    HappinessPlanner,
    OnlineCheckIn,
    Delay,
    ProcedureOnSite,
    Arrival,
    Contact,
    Checklist,
    OpeningHours,
    Experience,
    Gastronomy,
    Shops,
    Upgrades,
    RitzCarlton,
    AdditionalServices,
    GuidedTours,
    Map,
    Details
}


